export default "__VITE_ASSET__2V06SyeE__"